export { default } from "./GlobalStyles.mjs";